import { Visibility, VisibilityOff, Add } from '@mui/icons-material';
import {
  Box,
  Chip,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip
} from '@mui/material';
import { useEffect, useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import CustomModal from '../customModal/CustomModal';
import EIN_Info_Image from '../../assets/images/EIN.png';

interface FormikTextFieldProps {
  disabled?: boolean;
  name: string;
  label: string;
  type: string;
  fieldValue?: {
    value: string | any;
    onBlur?: () => void;
  };
  handleChange: any;
  isErrorField?: boolean;
  required?: boolean;
  multipleTagInput?: boolean;
}

export default function FormikTextField({
  disabled = false,
  name,
  label,
  type,
  fieldValue,
  handleChange,
  isErrorField = false,
  required = false,
  multipleTagInput = false
}: FormikTextFieldProps) {
  const [showEINInfo, setShowEINInfo] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [chipValue, setChipValue] = useState<string[]>([]);

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const addChip = () => {
    if (
      fieldValue.value.trim() &&
      !chipValue.includes(fieldValue.value.trim())
    ) {
      setChipValue([...chipValue, fieldValue.value.trim()]);
      handleChange({
        target: { value: '' }
      } as React.ChangeEvent<HTMLInputElement>);
    }
  };

  const handleDelete = (item: string) => {
    setChipValue(chipValue.filter((val) => val !== item));
  };

  useEffect(() => {
    let value = fieldValue?.value;
    if (value?.length > 0) {
      if (typeof value === 'string') {
        value = value.split(',');
      }
      setChipValue(value);
    } else {
      setChipValue([]);
    }
  }, [fieldValue]);

  return (
    <Box className="appointment-dropdown">
      <TextField
        error={required && !fieldValue?.value && isErrorField}
        fullWidth
        disabled={disabled}
        id={name}
        name={name}
        label={label}
        type={showPassword ? 'text' : type}
        className={
          type !== 'note'
            ? `input-field-styling${required ? ' required-field' : ''}`
            : undefined
        }
        value={fieldValue?.value}
        onChange={handleChange}
        onBlur={fieldValue?.onBlur}
        multiline={type === 'note'}
        InputLabelProps={{
          className: 'form-field-label required-label weight-600'
        }}
        slotProps={{ htmlInput: { maxLength: name === 'EIN' ? 9 : 200 } }}
        InputProps={{
          rows: type === 'note' ? 3 : 1,
          endAdornment: (
            <>
              {type === 'password' && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={togglePasswordVisibility}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )}
              {multipleTagInput && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="add text as chip"
                    onClick={addChip}
                    edge="end"
                  >
                    <Add />
                  </IconButton>
                </InputAdornment>
              )}
              {name === 'EIN' && (
                <InputAdornment position="end">
                  <Tooltip title={'Click me to know more.'} arrow>
                    <IconButton
                      sx={{ px: 0 }}
                      onClick={() => setShowEINInfo(true)}
                    >
                      <InfoIcon color="primary" fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              )}
            </>
          )
        }}
      />
      {multipleTagInput &&
        chipValue.map((item) => (
          <Chip
            key={item}
            label={item}
            onDelete={() => handleDelete(item)}
            color="secondary"
          />
        ))}
      <CustomModal
        title={'EIN (Employer Identification Number) Information'}
        IsOpen={showEINInfo}
        setIsOpen={setShowEINInfo}
        actionButtons={['Close']}
        loading={false}
        content={
          <Box>
            <img src={EIN_Info_Image} alt="EIN-Info" />
          </Box>
        }
      />
    </Box>
  );
}
